import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('tableDataManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('tableDataManagementStore', Object.keys(actions)),
	...mapMutations('tableDataManagementStore', Object.keys(mutations))
};
